import React, { useEffect } from "react";
import TicketNoBuy from "../component/TicketNoBuy";
import PreviousBarInvoice from "../component/PreviousBarInvoice"
import { useNavigate, useLocation } from "react-router-dom";
import { getTickets } from '../features/lotteryInvoice'
import { useSelector, useDispatch } from 'react-redux';
import numToFixed, { numToFixed2 } from "../helper/numToFixed";
import { changeTypeToName } from "../helper/changeBankIdtoName";
import PrintIcon from '@mui/icons-material/Print';

const CardHead = (props) => (
  <div
    className={`${props.isCancel == "yes"
      ? "bg-defaultStatusCancel text-defaultStatusCancel2"
      : props.isWin == "yes"
        ? "bg-defaultStatusWin text-defaultStatusWin2"
        : props.isWin == "no"
          ? "bg-defaultStatusLost text-defaultStatusLost2"
          : "bg-defaultStatusWatting text-defaultStatusWatting2"
      } rounded-t`}
  >
    <div className="px-1 py-2">
      <div className="text-center font-bold px-1 flex justify-between text-normal text-defaultPoyName">
        <p>{props.lotteryName}</p>
        <p>โพย #{props.refCode}</p>
      </div>
      <div className="text-center text-sm px-1 flex justify-between text-defaultTextMenuMobile2">
        <p>รอบ: {props.yeekeeRound ? props.yeekeeRound : new Date(props.closeSaleDatetime).toLocaleDateString("th-TH")}</p>
        <p>เวลาซื้อ: {new Date(props.date).toLocaleString("th-TH")}</p>
      </div>
    </div>
    <div className="text-left px-2">
      <p>บันทึกโพย: {props.remark}</p>
    </div>
    <div className="text-center px-2 pt-1 flex justify-between bg-white">
      <div className="text-left">
        <p className="text-normal text-defaultTextMenuMobile2">ยอดแทง: <span className="text-defaultStatusWin2 font-bold">{numToFixed(props.totalBetAmount)}<span style={{ fontFamily: 'Menlo' }}>฿</span></span></p>
      </div>
      <div className="text-left">
        <p className="text-normal text-defaultTextMenuMobile2">รางวัล: {' '}
          <span className={`text-normal font-bold  ${props.result?.length ?
            props.winLoseAmount > 0 ? `text-defaultStatusWin2` : `text-defaultStatusLost2` : `text-defaultStatusWatting2`
            }`} style={{ fontFamily: 'Menlo' }}>
            {props.result?.length ? `${numToFixed(props.winLoseAmount)}฿` : 'รอผล'}
          </span>
        </p>
      </div>
    </div>
  </div>
);

const Card = (props) => {
  // console.log(props)
  var statusInvoice = ''
  if (props.data.isCancel == "yes") {
    statusInvoice = 'text-defaultStatusCancel2 bg-defaultStatusCancel'
  } else if (props.data.isWin == "yes") {
    statusInvoice = 'text-defaultStatusWin2 bg-defaultStatusWin'
  } else if (props.data.isWin == "no") {
    statusInvoice = 'text-defaultStatusLost2 bg-defaultStatusLost'
  } else {
    statusInvoice = 'text-defaultStatusWatting2 bg-defaultStatusWatting'
  }
  return (
    <>
      <div className="w-auto text-sm mx-1">
        <div className="grid grid-cols-12 text-xxs mx-1 mt-1.5">
          <div className="col-span-3 md:col-span-1 mt-x4 text-xxs text-defaultTextMenuMobile2">
            {'รายการที่ ' + props.i + '/' + props.length}
          </div>
          <div className={`${props.length <= 10 ? `` : ``} col-span-9 md:col-span-11 md:ml-0 mt-1 border-t border-gray-600`}></div>
        </div>
        <div className="grid gap-0.5 grid-cols-10 m-1 text-sm">
          <div className={"col-span-2 text-center w-full mb-1 pt-1 rounded px-1 " + statusInvoice}>
            <p className={`text-xs`}>{changeTypeToName(props.data.lotteryType)}</p>
            <p className="text-xs font-bold">
              {props.data.lotteryNumber}
            </p>
          </div>
          <div className={"col-span-2 w-full text-center mb-1 py-1 rounded px-1 " + statusInvoice}>
            <p className={`text-xs`}>เลขที่ออก</p>
            <p className={`text-xs font-bold`}>
              {resultNumber(props.result, props.lotteryType, props.isWin)}
            </p>
          </div>
          <div className={"col-span-3 w-full flex justify-between mb-1 py-1 rounded px-1 bg-white text-defaultTextMenuMobile2"}>
            <div>
              <p className={`text-xs`}>ราคาซื้อ</p>
              <p className={`text-xs font-bold`}>
                {numToFixed2(props.data.betAmount)}
                <span style={{ fontFamily: 'Menlo' }}>฿</span>
              </p>
            </div>
            <div>
              <p className={`text-xs`}>บาทละ</p>
              <p className={`text-xs font-bold`}>
                {numToFixed2(props.data.rewardRate)}
                <span style={{ fontFamily: 'Menlo' }}>฿</span>
              </p>
            </div>
          </div>
          <div className={"col-span-3 w-full mb-1 py-1 rounded px-1 text-right " + statusInvoice}>
            <p className={`text-xs`}>ผลได้เสีย</p>
            <span
              className={`font-bold text-normal`}
            >
              {props.data.isWin == "yes"
                ? `${numToFixed(props.data.rewardAmount)}`
                : `0.00`}
              <span style={{ fontFamily: 'Menlo' }}>฿</span>
            </span>
          </div>
        </div>
      </div>

    </>
  );
};

const resultNumber = (result, ticketType, isWin) => {
  let results = "";
  if (result.length && isWin != 'wait') {
    result.map((data) => {
      if (data.betType == ticketType) {
        results = data.betNumber.toString();
      }
    });
    return results;
  } else {
    return 'รอผล'
  }

};

const InvoiceInfomation = React.forwardRef((props, ref) => {
  const location = useLocation();
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const tickets = useSelector((state) => state.invoice.ticket);

  var lotteryName = '';
  var yeekeeRound = '';
  var stringLength = '';

  if (location?.state?.lotteryName) {
    if (location?.state?.lotteryName.substring(0, 11) == 'จับยี่กี 5G SUPER') {
      lotteryName = 'จับยี่กี 5G SUPER'
      stringLength = location?.state?.lotteryName.length
      yeekeeRound = location?.state?.lotteryName.substring(19, stringLength)
    } else if (location?.state?.lotteryName.substring(0, 8) == 'จับยี่กี SUPER') {
      lotteryName = 'จับยี่กี SUPER'
      stringLength = location?.state?.lotteryName.length
      yeekeeRound = location?.state?.lotteryName.substring(16, stringLength)
    } else {
      lotteryName = location?.state?.lotteryName
    }
  }

  useEffect(() => {
    // console.log("location", location)
    if (location?.state?._id) {
      const body = { id: location?.state?._id };
      dispatch(getTickets(body));
    } else {
      navigate('/historyhuay')
    }
  }, [])

  return (
    <>
      <div className="w-full text-right text-[#b3853e] text-sm">
        <button onClick={() => navigate(
          '/previewprint',
          {
            state: {
              cancelData: location?.state.cancelData,
              closeSaleDatetime: location?.state.closeSaleDatetime,
              currency: location?.state.currency,
              invoiceDatetime: location?.state.invoiceDatetime,
              isCancel: location?.state.isCancel,
              isWin: location?.state.isWin,
              lotteryId: location?.state.lotteryId,
              lotteryName: location?.state.lotteryName,
              refCode: location?.state.refCode,
              totalBetAmount: location?.state.totalBetAmount,
              totalPayAmount:location?.state.totalPayAmount,
              totalWinLoseAmount: location?.state.totalWinLoseAmount,
              _id: location?.state._id,
              remark: location?.state.remark
            }
          })}>
          <PrintIcon />
        </button>
      </div>
      <div className="md:mx-10 w-auto rounded-lg border border-[#b3853e] pb-10 text-center text-[#b3853e] px-1 md:px-10 font-bold">
        <PreviousBarInvoice data={location?.state} lotteryRound={tickets} />
        <div className="grid grid-cols-1 gap-0">
          <div
            ref={ref}
            className={`${location?.state.isCancel == "yes"
              ? "border-defaultStatusCancel2"
              : location?.state.isWin == "yes"
                ? "border-defaultStatusWin2"
                : location?.state.isWin == "no"
                  ? "border-defaultStatusLost2"
                  : "border-defaultStatusWatting2"
              } w-auto h-auto mx-1 mt-1 border text-sm bg-white border-dashed`}
          >
            <CardHead
              name={location?.state.lotteryName}
              date={location?.state.invoiceDatetime}
              result={tickets?.results}
              totalBetAmount={tickets?.totalBetAmount}
              winLoseAmount={tickets?.totalPayAmount}
              refCode={location?.state.refCode}
              lotteryName={lotteryName}
              yeekeeRound={yeekeeRound}
              closeSaleDatetime={location?.state.closeSaleDatetime}
              isWin={location?.state.isWin}
              isCancel={location?.state.isCancel}
              remark={location?.state.remark}
            />
            <div className="border-gray-800">
              {/* {console.log(tickets.ticketList)} */}
              {tickets.ticketList?.map((data, i) => (
                // console.log(data)
                <Card
                  key={i}
                  i={i + 1}
                  result={tickets?.results}
                  lotteryType={data.lotteryType}
                  isWin={data.isWin}
                  data={data}
                  length={tickets?.ticketList.length}
                />
              ))}
            </div>
            {location.state.lotteryId === "63c4f776743b79857e6a654e" ?
              <div className="grid grid-cols-2 gap-2 md:grid-cols-4 pt-5 p-5">
                {tickets.ticketList?.map((data, i) => (
                  // console.log(data)
                  <TicketNoBuy data={data} />
                ))}

              </div> :
              <></>
            }
          </div>
        </div>

      </div>
    </>
  );
});

export default InvoiceInfomation;
